
import clsx from 'clsx';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  actions?: React.ReactNode;
  vertical?: 'center' | 'top';
  className?: string;
}

/**
 * Standard empty/error state treatment with optional actions.
 */
export function EmptyState({
  icon,
  title,
  description,
  actions,
  vertical = 'center',
  className,
}: EmptyStateProps) {
  return (
    <div
      className={clsx(
        'flex w-full flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-gray-200 bg-gray-50 px-6 py-12 text-center text-sm text-gray-600 dark:border-gray-700 dark:bg-gray-900/50 dark:text-gray-400',
        vertical === 'top' && 'justify-start text-left sm:items-start sm:text-left',
        className,
      )}
    >
      {icon && (
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-yellow-500 shadow-sm dark:bg-gray-800/60">
          {icon}
        </div>
      )}
      <div className="space-y-1">
        <h3 className="text-base font-semibold text-gray-900 dark:text-white">{title}</h3>
        {description && <p className="text-sm text-gray-600 dark:text-gray-400">{description}</p>}
      </div>
      {actions && <div className="mt-2 flex flex-wrap items-center justify-center gap-2">{actions}</div>}
    </div>
  );
}
